// Third-party
import React from 'react';

// Utils
import { getColorFromString } from '../../../utils/colors';
import { getContactInitials } from '../../../utils/contacts';

// Components
import Avatar from '../avatar/Avatar';
import GenericContact from '@/types/generic-contact';
import AdvisorInfos from '@/types/advisor-infos';

interface Props {
  contact: GenericContact | AdvisorInfos;
  backgroundColor?: string;
  borderColor?: string;
}

const LegacyContactPastille = ({ contact, backgroundColor, borderColor }: Props) => {
  const initials = getContactInitials(contact);

  if (!contact._id) {
    return null;
  }

  const bgColor = !backgroundColor ? getColorFromString(contact._id) : backgroundColor;

  return (
    <div className="contact-pastille">
      <Avatar backgroundColor={bgColor} borderColor={borderColor || bgColor}>
        {initials}
      </Avatar>
    </div>
  );
};

export default LegacyContactPastille;
